import {mapTimestampToDate} from '@coolcolduk/firebase-util';
import z from 'zod';

/**
 * Convert a Firestore Timestamp to a Date.
 * Uses mapTimestampToDate to convert the value.
 */
export const firestoreTimestampToDateSchema = z.preprocess((value) => mapTimestampToDate(value as never), z.date());
